module.exports = __webpack_public_path__ + "img/OTHER.98e9701e.svg";